module.exports = __webpack_public_path__ + "assets/img/wheel.1613bc6b.png";